export default __webpack_public_path__ + "static/media/1758.aa9ccfc9.png";